var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-dialog',{class:_vm.currentThemeClass,attrs:{"title":_vm.title,"data":_vm.item,"width":"80%","visible":_vm.visibleSync,"columns":_vm.columnList,"footerVisible":_vm.footerVisible},on:{"update:visible":function($event){_vm.visibleSync=$event},"confirm":_vm.confirmForm,"extrabutton-click":_vm.ExtraButtonClick}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0da5efc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scheduling/EditSurgeryNew.vue
// module id = null
// module chunks = 